<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lnm06f/tc-custom/CoverDesign.jpg?1684604109879?1717877783662" alt="This image is the cover for the book Dog Days, Wolf Winter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dog Days, Wolf Winter
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Wolf Winter Novel</i></b></p><p>The world ends not with a bang, but with a downpour. Tornadoes spin through the heart of London, New York cooks in a heat wave that melts tarmac, and Russia freezes under an ever-thickening layer of permafrost. People rally at first—organizing aid drops and evacuating populations—but the weather is only getting worse.</p><p>In Durham, mild-mannered academic Danny Fennick has battened down to sit out the storm. He grew up in the Scottish Highlands, so he’s seen harsh winters before. Besides, he has an advantage. He’s a werewolf. Or, to be precise, a weredog. Less impressive, but still useful.</p><p>Except the other werewolves don’t believe this is any ordinary winter, and they’re coming down over the Wall to mark their new territory. Including Danny’s ex, Jack—the Crown Prince Pup of the Numitor’s pack—and the prince’s brother, who wants to kill him.</p><p>A wolf winter isn’t white. It’s red as blood.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        TA Moore
      </h2>
      
      <p class="authorDescription body article"><P>TA Moore is a Northern Irish writer of romantic suspense, urban fantasy, and contemporary romance novels. A childhood in a rural seaside town fostered a suspicious nature, a love of mystery, and a streak of black humour a mile wide. As her grandmother always said, &ldquo;She&rsquo;d laugh at a bad thing, that one,&rdquo; mind you, that was the pot calling the kettle black. TA studied history, Irish mythology, and English at University, mostly because she has always loved a good story. She has worked as a journalist, a finance manager, and in the arts sectors before she finally gave in to a lifelong desire to write.</P><P>Coffee, Doc Marten boots, and good friends are the essential things in life. Spiders, mayo, and heels are to be avoided.</P><P>Website: www.nevertobetold.co.uk</P><P>Facebook: www.facebook.com/TA.Moores</P><P>Twitter: @tammy_moore</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50823324